import { lpRequest } from '../../../../core/utils/lp-backend';
import { ITrackingSettings } from '../../domain/entities/settings-entity';
import { toSettings } from '../repositories/settings-repository-impl';
import { readSettings } from './settings-fields';

/**
 * `PATCH /client/settings/fields {tracking: {appearance, custom_messages}}`. loop-pro merges both maps key by key
 * where cb replaced them; the form sends every key of both.
 */
export const editTrackingSettings = async (settings: ITrackingSettings): Promise<any> => {
  await lpRequest('PATCH', '/client/settings/fields', {
    body: {
      tracking: { appearance: settings.appearance, custom_messages: settings.custom_messages }
    }
  });

  return toSettings(await readSettings());
};
